/**
 * An enumeration of the available LogLevels.
 */
export enum LogLevel {
  Debug,
  Warning,
  Error
}
